<template>
  <v-flex xs12 sm10 md6 class="entry__container">
    <div class="app-logo text-xs-center pb-5">
      XProperty
    </div>
    <v-card elevation="2" class="pa-4">
      <v-card-title primary-title class="py-3">
        <h1>Register</h1>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-layout row wrap>
            <v-text-field
              v-model="firstName"
              label="First Name"
              :rules="nameRules"
              required
            />
            <v-text-field
              v-model="lastName"
              label="Last Name"
              :rules="nameRules"
              required
            />
          </v-layout>
          <v-text-field
            v-model="email"
            label="Email"
            :rules="emailRules"
            required
          />
          <v-text-field
            v-model="firstPassword"
            label="Password"
            :rules="passwordRules"
            required
            :type="'password'"
          />
          <v-text-field
            v-model="secondPassword"
            label="Password Again"
            :rules="passwordRules"
            required
            :type="'password'"
          />
          <p v-if="passwordNotMatch" class="red--text"
            >Password does not match</p
          >
        </v-form>
      </v-card-text>
      <v-card-actions class="py-3">
        <v-btn :disabled="valid" flat router to="/">Login</v-btn>
        <v-btn :disabled="valid" flat router to="/forgetPassword">Forgot Password</v-btn>
        <v-spacer></v-spacer>
        <v-btn :disabled="!valid" color="primary" @click="register"
          >Register</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-flex>
</template>

<script>
import alertHelper from '@/helpers/alert'
export default {
  data: () => ({
    firstName: '',
    lastName: '',
    email: '',
    firstPassword: '',
    secondPassword: '',
    valid: true,
    passwordNotMatch: false,
    emailRules: [
      (v) => !!v || 'E-mail is required',
      (v) => /.+@.+\.+/.test(v) || 'E-mail must be valid',
    ],
    nameRules: [
      (v) => !!v || 'Name is required',
      (v) => (v && v.length <= 10) || 'Name must be less than 10 characters',
    ],
    passwordRules: [
      (v) => !!v || 'Password is required',
      (v) => (v && v.length >= 6) || 'Password must be more than 6 characters',
    ],
  }),
  computed: {},
  methods: {
    register() {
      if (this.$refs.form.validate()) {
        if (this.firstPassword === this.secondPassword) {
          this.passwordNotMatch = false
        } else {
          this.passwordNotMatch = true
        }
      } else {
        alertHelper.error('Please enter the required details')
      }
    },

  },
}
</script>
